/**
 * #2481: what a draft connection still needs before it is ready, said in the words of its
 * connector. A report connection (GA4) has no table to select: the person adds reports, so a
 * connection that already has one needs only its validation. One rule for every screen and for the
 * server's refusals, so a connection never reads two different next steps.
 */
export type SetupNeed = "table" | "report" | "validate";

export function setupNeedOf(reportsConnector: boolean, selectedCount: number): SetupNeed {
  if (!reportsConnector) return "table";
  return selectedCount > 0 ? "validate" : "report";
}

/** The status badge's and the save bar's hover hint for a connection with its setup unfinished. */
export const SETUP_HINT: Record<SetupNeed, string> = {
  table: "Validate the connection and select at least one table to finish its setup.",
  report: "Validate the connection and add at least one report to finish its setup.",
  validate: "Validate the connection to finish its setup.",
};

/** Why Import now is off for a draft. */
export const IMPORT_NOT_READY_BY_NEED: Record<SetupNeed, string> = {
  table: "Finish the setup first: validate the connection and select a table.",
  report: "Finish the setup first: validate the connection and add a report.",
  validate: "Finish the setup first: validate the connection.",
};

const ISSUE_TAIL: Record<SetupNeed | "either", string> = {
  table: "Validate its credentials and select at least one table.",
  report: "Validate its credentials and add at least one report.",
  validate: "Validate its credentials.",
  either: "Validate its credentials and select at least one table or add a report.",
};

/** A refusal naming a connection that has not finished setup. `null`: the caller cannot tell. */
export function setupNotFinishedIssue(name: string, need: SetupNeed | null): string {
  return `${name} has not finished setup. ${ISSUE_TAIL[need ?? "either"]}`;
}
